import { render, staticRenderFns } from "./UsuariosComp.vue?vue&type=template&id=5013b1b9&"
import script from "./UsuariosComp.vue?vue&type=script&lang=js&"
export * from "./UsuariosComp.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UsuariosComp.vue"
export default component.exports